// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Search_loaderContainer__xZemb"};